import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#mixed-input" }),
  /*#__PURE__*/_createTextVNode(" Mixed input ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Prepend or append an element, generally a label or a button. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Http://")
const _hoisted_6 = { style: {"margin-top":"15px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(".com")
const _hoisted_8 = { style: {"margin-top":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _createVNode(_component_el_input, {
          placeholder: "Please input",
          modelValue: _ctx.input1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.input1 = $event))
        }, {
          prepend: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_input, {
          placeholder: "Please input",
          modelValue: _ctx.input2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.input2 = $event))
        }, {
          append: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_el_input, {
          placeholder: "Please input",
          modelValue: _ctx.input3,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.input3 = $event)),
          class: "input-with-select"
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.select,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.select = $event)),
              placeholder: "Select"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Restaurant",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "Order No.",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "Tel",
                  value: "3"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          append: _withCtx(() => [
            _createVNode(_component_el_button, { icon: "el-icon-search" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code8), 1)
        ]),
        _: 1
      })
    ])
  ]))
}